<template>
  <section>
    <HeadingLv2 text="連載" icon="series" />
    <div class="list">
      <SimpleCard
        v-for="(content, index) in displayContents"
        :key="content.id"
        :heading="content.title"
        :category="content.category"
        :description="content.description"
        :image="content.imageUrl"
        :imageAlt="content.imageAlt"
        :path="content.path"
        :url="content.externalLinkUrl"
        :isList="index !== 0"
      />
    </div>
    <Button
      href="/magazines/series"
      :handleClick="moveToSeriesIndex"
      label="連載一覧へ"
      primary
    />
  </section>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router'
import SimpleCard from '@/components/block/SimpleCard.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import { MagazineSpecialRecommendContent } from '@/types/MagazineRecommend'

export default defineComponent({
  name: 'HomeRecommendSeries',

  components: {
    SimpleCard,
    HeadingLv2,
    Button
  },

  props: {
    contents: {
      type: Array as PropType<MagazineSpecialRecommendContent[]>,
      default: () => []
    }
  },

  setup(props) {
    const router = useRouter()
    const moveToSeriesIndex = () => {
      router.push(`/magazines/series`)
    }
    return {
      displayContents: computed(() => props.contents.slice(0, 4)),
      moveToSeriesIndex
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.list {
  margin-top: 20px;
  margin-bottom: 30px;
  ::v-deep(.simpleCard) {
    &:first-child {
      padding-bottom: 20px;
    }
  }
  @include mixins.media() {
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 40px;
    ::v-deep(.simpleCard) {
      &:first-child {
        grid-row-start: 1;
        grid-row-end: 4;
        padding-bottom: 0;
      }
      &:not(:first-child) {
        grid-column-start: 2;
      }
      &:nth-child(2) a {
        padding-top: 0;
      }
      &:nth-child(4) a {
        padding-bottom: 0;
      }
    }
  }
}
</style>
